import {createIcon, createSymbolIcon} from './Icon.utils';

export const AccountBalanceIcon = createIcon('account_balance');
export const AccountCircleOutlinedIcon = createIcon('account_circle_outlined');
export const AddIcon = createIcon('add');
export const AddLocationIcon = createIcon('add_location');
export const AppleIcon = createIcon('apple');
export const AppsIcon = createIcon('apps');
export const ArrowBackIcon = createIcon('arrow_back');
export const ArrowDropDownIcon = createIcon('arrow_drop_down');
export const AttachFileIcon = createIcon('attach_file');
export const CallIcon = createIcon('call');
export const CancelOutlinedIcon = createIcon('cancel_outlined');
export const CastOutlinedIcon = createIcon('cast_outlined');
export const ChatIcon = createIcon('chat');
export const ChatOutlinedIcon = createIcon('chat_outlined');
export const CheckCircleOutlinedIcon = createIcon('check_circle_outlined');
export const CheckCircleIcon = createIcon('check_circle');
export const CheckIcon = createIcon('check');
export const ChevronLeftIcon = createIcon('chevron_left');
export const ChevronRightIcon = createIcon('chevron_right');
export const ChevronRightOutlinedIcon = createIcon('chevron_right_outlined');
export const CircleRoundedIcon = createIcon('circle_rounded');
export const CloseIcon = createIcon('close');
export const CreditCardOutlinedIcon = createIcon('credit_card_outlined');
export const DeleteIcon = createIcon('delete');
export const DescriptionIcon = createIcon('description');
export const DeviceHubIcon = createIcon('device_hub');
export const DevicesOutlinedIcon = createIcon('devices_outlined');
export const DevicesOtherOutlinedIcon = createIcon('devices_other_outlined');
export const DnsOutlinedIcon = createIcon('dns_outlined');
export const DomainIcon = createIcon('domain');
export const EmailIcon = createIcon('email');
export const EmailRoundedIcon = createIcon('email_rounded');
export const ErrorIcon = createIcon('error');
export const ErrorOutlineIcon = createIcon('error_outline');
export const ExpandLessIcon = createIcon('expand_less');
export const ExpandMoreIcon = createIcon('expand_more');
export const ExpandMoreOutlinedIcon = createIcon('expand_more_outlined');
export const FacebookRoundedIcon = createIcon('facebook_rounded');
export const FiberPinIcon = createIcon('fiber_pin');
export const FileUploadOutlinedIcon = createIcon('file_upload_outlined');
export const FirstPageIcon = createIcon('first_page');
export const GroupOutlinedIcon = createIcon('group_outlined');
export const HelpIcon = createIcon('help');
export const HelpOutlineIcon = createIcon('help_outline');
export const HomeOutlinedIcon = createIcon('home_outlined');
export const HubOutlinedIcon = createIcon('hub_outlined');
export const InfoOutlinedIcon = createIcon('info_outlined');
export const InsertInvitationIcon = createIcon('insert_invitation');
export const KeyboardArrowDownIcon = createIcon('keyboard_arrow_down');
export const LanguageOutlinedIcon = createIcon('language_outlined');
export const LastPageIcon = createIcon('last_page');
export const LaunchOutlinedIcon = createIcon('launch_outlined');
export const LensIcon = createIcon('lens');
export const LensOutlinedIcon = createIcon('lens_outlined');
export const LocalPhoneIcon = createIcon('local_phone');
export const LocationOnOutlinedIcon = createIcon('location_on_outlined');
export const LockIcon = createIcon('lock');
export const LockOutlinedIcon = createIcon('lock_outlined');
export const MailOutlinedIcon = createIcon('mail_outlined');
export const MenuIcon = createIcon('menu');
export const MinimizeIcon = createIcon('minimize');
export const NavigateBeforeIcon = createIcon('navigate_before');
export const NavigateNextIcon = createIcon('navigate_next');
export const NetworkCheckOutlinedIcon = createIcon('network_check_outlined');
export const OfflineBoltIcon = createIcon('offline_bolt');
export const OpenInNewIcon = createIcon('open_in_new');
export const PasswordIcon = createIcon('password');
export const PaymentsIcon = createIcon('payments');
export const PersonOutlinedIcon = createIcon('person_outlined');
export const PhoneOutlinedIcon = createIcon('phone_outlined');
export const PinIcon = createIcon('pin');
export const PlayCircleOutlineIcon = createIcon('play_circle_outline');
export const PublicOutlinedIcon = createIcon('public_outlined');
export const RemoveIcon = createIcon('remove');
export const RouterOutlinedIcon = createIcon('router_outlined');
export const ScheduleOutlinedIcon = createIcon('schedule_outlined');
export const SearchOutlinedIcon = createIcon('search_outlined');
export const SettingsInputHdmiOutlinedIcon = createIcon(
  'settings_input_hdmi_outlined',
);
export const SettingsOutlinedIcon = createIcon('settings_outlined');
export const SettingsRemoteOutlinedIcon = createIcon(
  'settings_remote_outlined',
);
export const SignalWifiOffOutlinedIcon = createIcon('signal_wifi_off_outlined');
export const SignalWifiStatusbarConnectedNoInternet4OutlinedIcon = createIcon(
  'signal_wifi_statusbar_connected_no_internet_4',
);
export const SmartphoneOutlinedIcon = createIcon('smartphone_outlined');
export const SpeedOutlinedIcon = createIcon('speed_outlined');
export const SupportOutlinedIcon = createIcon('support_outlined');
export const TaskAltIcon = createIcon('task_alt');
export const TextSnippetOutlinedIcon = createIcon('text_snippet_outlined');
export const TripOriginRoundedIcon = createIcon('trip_origin_rounded');
export const ViewCarouselOutlinedIcon = createIcon('view_carousel_outlined');
export const VisibilityIcon = createIcon('visibility');
export const VisibilityOffIcon = createIcon('visibility_off');
export const VisibilityOffOutlinedIcon = createIcon('visibility_off_outlined');
export const VisibilityOutlinedIcon = createIcon('visibility_outlined');
export const WarningAmberIcon = createIcon('warning_amber');
export const WarningAmberOutlinedIcon = createIcon('warning_amber_outlined');
export const WifiIcon = createIcon('wifi');
export const WifiOutlinedIcon = createIcon('wifi_outlined');
export const WifiLockOutlinedIcon = createIcon('wifi_lock_outlined');
export const WifiTetheringOutlinedIcon = createIcon('wifi_tethering_outlined');
export const PasskeySymbolIcon = createSymbolIcon('passkey');
export const DeleteSymbolIcon = createSymbolIcon('delete');
export const NotificationImportantOutlinedIcon = createSymbolIcon(
  'notification_important_outlined',
);
export const BatteryIcon = createSymbolIcon('battery_charging_20_outlined');
export const PriorityRoomIcon = createSymbolIcon('nest_multi_room');
export const DefaultBuildIcon = createSymbolIcon('build_outlined');
export const EngineeringIcon = createSymbolIcon('engineering');
